// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComptabiliteModalSave_checkbox__3NV21 {\n  right: 24px;\n  position: absolute;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Comptabilite/ComptabiliteModalSave.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".checkbox {\n  right: 24px;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": "ComptabiliteModalSave_checkbox__3NV21"
};
export default ___CSS_LOADER_EXPORT___;
